import { defineMessages } from 'react-intl';

export default defineMessages({
    paymentHistory: {
        id: "ent.billing.billing-summary.Payment History",
        defaultMessage: "Payment History"
    },
    appliedDate: {
        id: "ent.billing.billing-summary.Applied Date",
        defaultMessage: "Applied Date"
    },
    receivedDate: {
        id: "ent.billing.billing-summary.Received Date",
        defaultMessage: "Received Date"
    },
    reversedDate: {
        id: "ent.billing.billing-summary.Reversed Date",
        "defaultMessage": "Reversed Date"
    },
    checkRefNumber: {
        id: "ent.billing.billing-summary.Check/Ref Number",
        defaultMessage: "Check/Ref Number"
    },
    paymentMethod: {
        id: "ent.billing.billing-summary.Payment Method",
        defaultMessage: "Payment Method"
    },
    amount: {
        id: "ent.billing.billing-summary.Amount",
        defaultMessage: "Amount"
    },
    totalAmountApplied: {
        id: "ent.billing.billing-summary.Total Amount Applied",
        defaultMessage: "Total Amount Applied:"
    },
    noMatchingPayments: {
        id: "ent.billing.billing-summary.No payment data available for this policy period",
        defaultMessage: "No payment data available for this policy period."
    },   
    
});
